import { keyStorage } from 'constants/globals'

type SessionUser = {
  accessToken?: string
  refreshToken?: string
}

let authReadyPromise: Promise<void> | null = null
let resolveAuthReady: (() => void) | null = null
let authReadyAtMs = 0

const readSessionUser = (): SessionUser | null => {
  try {
    const raw = sessionStorage.getItem(keyStorage.user)
    if (!raw) return null
    return JSON.parse(raw) as SessionUser
  } catch {
    return null
  }
}

const hasAuthSession = (): boolean => {
  const user = readSessionUser()
  return Boolean(user?.accessToken && user?.refreshToken)
}

export const waitForAuthReady = (): Promise<void> => {
  if (hasAuthSession()) {
    authReadyAtMs = Date.now()
    return Promise.resolve()
  }
  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve) => {
      resolveAuthReady = resolve
    })
  }
  return authReadyPromise
}

export const markAuthReady = (): void => {
  authReadyAtMs = Date.now()
  if (resolveAuthReady) resolveAuthReady()
  authReadyPromise = null
  resolveAuthReady = null
}

export const resetAuthReady = (): void => {
  authReadyAtMs = 0
  authReadyPromise = null
  resolveAuthReady = null
}

export const isInImmediateAuthWindow = (ms = 15000): boolean => {
  if (!authReadyAtMs) return false
  return Date.now() - authReadyAtMs < ms
}

